import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-card-loader',
  templateUrl: './card-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./card-loader.component.scss'],
})
export class CardLoaderComponent {
  @Input() isVerticalCard?: boolean;
}
